import React, { Component } from 'react';
import { connect } from 'react-redux';
import { modalActions, accountActions } from '../../../redux/root-action';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import ReactModalFooter from '../../Modal/ReactModalFooter';
import ReactModalHeader from '../../Modal/ReactModalHeader';
import ReactModalContent from '../../Modal/ReactModalContent';
import { accountModalViews, postActions, analyticsTracking } from '../../../utils/constants';

const DeleteAccountTextContainer = styled.div`
  margin: 32px 0 56px;
`;

const DeleteAccountText = styled.span`
  font-family: 'Nimbus Sans Light';
  font-size: 20px;
  line-height: 26px;
  letter-spacing: -0.5px;
  color: ${tokens.ColorGrey900};

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 22px;
  }
`;

const PlanName = styled.span`
  font-family: Nimbus Sans Bold;
`;

class DeleteAccountModal extends Component<any> {
  props: any;
  state: any;

  handleDelete = () => {
    const { updateAccountsData, accounts, selectedAccount } = this.props;
    const tempAccounts = [...accounts];
    tempAccounts[selectedAccount.accountIndex] = { ...selectedAccount, action: postActions.DELETE };
    updateAccountsData({ accounts: tempAccounts });
    this.returnToAccounts();
  };

  returnToAccounts = () => {
    const { setCurrentView } = this.props;
    setCurrentView(accountModalViews.YOUR_ACCOUNTS);
  };

  render(): JSX.Element {
    const mq = window.matchMedia('(max-width: 768px)');
    const { selectedAccount } = this.props;
    return (
      <React.Fragment>
        <ReactModalHeader modalTitle="Delete Account" showClose={mq.matches ? true : false} />
        <ReactModalContent>
          <DeleteAccountTextContainer>
            <DeleteAccountText>
              Deleting this account will permanently remove it from your retirement savings balances and projections
              throughout the site. You might want to exclude this account instead so you can access it in the future.
            </DeleteAccountText>
            <br />
            <br />
            {mq.matches ? (
              <PlanName>Delete {selectedAccount.name}?</PlanName>
            ) : (
              <>
                <DeleteAccountText>
                  Delete <PlanName>{selectedAccount.name}</PlanName>?
                </DeleteAccountText>{' '}
              </>
            )}
          </DeleteAccountTextContainer>
        </ReactModalContent>
        <ReactModalFooter
          CTAButtonText="Delete"
          buttonType="alert"
          handleCancelClick={this.returnToAccounts}
          handleCTAClick={this.handleDelete}
          CTAButtonId={analyticsTracking.RIXDeleteAccount}
        />
      </React.Fragment>
    );
  }
}

export default connect(
  (state: any) => ({
    selectedAccount: state.account.selectedAccount,
    accounts: state.account.tempScenario.accounts,
  }),
  {
    showModal: modalActions.showModal,
    setCurrentView: accountActions.setCurrentView,
    updateAccountsData: accountActions.updateAccountsData,
  },
)(DeleteAccountModal);
